// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","button":"ViewModeToggle-module--button--6e057e"};